import { useState } from "react";

import ARCCard from "components/ARC/ARCCard";

import { ReactComponent as SyncedIcon } from "assets/svgs/sync/Synced.svg";
import { Link } from "react-router-dom";
import { HAS_SYNC } from "lib/consts/flags";

import { ARCInfo } from "arcjs/common/arc_devices";
import { SelectedRobotContextType } from "pages/dashboard/FleetPage";
import { ARC, useFilteredMultiARCs } from "providers/MultiARCsControlProvider";

import FluidListView from "components/layout/FluidListView";
import { Fleet } from "types/fleet";
import { useFleet } from "providers/FleetProvider";

export type ARCListProps = {
    arcsInfo: ARCInfo[];
    horizontal?: boolean;
    cardClassNames?: string;
    selectedARCs?: string[];
    selectedARCsClassName?: string;
    robotSelection?: SelectedRobotContextType["robotSelection"];
    className?: string;
    cardOnClick?: (arc: ARC) => void;
};

const FleetOverview = ({
    className = "",
    fleet: { fleetName, id, arcs: arcsInfo },
}: React.HTMLProps<HTMLDivElement> & { fleet: Fleet }) => {
    const { arcs } = useFilteredMultiARCs({ arcSerials: arcsInfo.map((i) => i.serialNumber) });
    const { arcStatuses } = useFleet();
    const [editing, setEditing] = useState(false);
    return (
        <div className={`flex flex-col space-y-4 rounded-r10 bg-black90 px-4 py-3 ${className}`}>
            <div className="flex w-full  items-center justify-between">
                <div className="flex w-full items-center justify-between space-x-3">
                    <p className="text-h3">{fleetName}</p>
                    <button
                        type="button"
                        className="text-h5 text-black40 hover:text-white"
                        onClick={() => setEditing((prev) => !prev)}
                    >
                        {editing ? "Done" : "Edit"}
                    </button>
                </div>
                {HAS_SYNC && <SyncedIcon />}

                {/* <Link to={`/fleet/${id}`}>More</Link> */}
            </div>
            <div className="flex">
                <FluidListView horizontal={true}>
                    {arcs && arcs.length > 0 ? arcs.map((arc) => (
                        <ARCCard
                            key={arc.serialNumber}
                            arc={arc}
                            arcStatus={arcStatuses[arc.serialNumber]}
                            editing={editing}
                        />
                    )) : <p className="text-h5 text-black40">No ARCs yet</p>}
                </FluidListView>
            </div>
        </div>
    );
};

export default FleetOverview;
